import { PartialType } from '../../../../utils';
import { CreateDaily357InsuranceFeeDto } from './create-daily-357-insurance-fee.dto';
export class UpdateDaily357InsuranceFeeDto extends PartialType(CreateDaily357InsuranceFeeDto) {
}
